import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const CheckboxSquare = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99992 14.6663H9.99992C13.3333 14.6663 14.6666 13.333 14.6666 9.99967V5.99967C14.6666 2.66634 13.3333 1.33301 9.99992 1.33301H5.99992C2.66659 1.33301 1.33325 2.66634 1.33325 5.99967V9.99967C1.33325 13.333 2.66659 14.6663 5.99992 14.6663Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.16675 7.99995L7.05341 9.88661L10.8334 6.11328"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    "CheckboxSquare",
  ),
);

export default CheckboxSquare;
